/*
 * vzone-modal-history.js v1.0
 * Adds URL + back-button handling to the Vehicle Zone quick-view modals.
 *
 * The theme's <quick-view> element deliberately does not touch history
 * (main-product-modal.liquid sets data-update-url="false"), so on mobile the
 * back button would leave the collection page instead of closing the panel.
 *
 * Behaviour:
 *   - Opening a zone modal pushes ?preview=<product-handle>
 *   - Browser back pops that entry and closes the panel
 *   - Closing by X / overlay / ESC / swipe calls history.back() so both
 *     paths stay in sync and no junk entries stack up
 *   - Landing on a ?preview= URL opens that panel, with a clean entry beneath
 *     it so the first back press closes rather than leaving the site
 *
 * Uses 'preview' rather than 'view' because 'view' is reserved by Shopify for
 * alternate template selection.
 */
(function () {
  if (window.__vzoneModalHistory) return;
  window.__vzoneModalHistory = true;

  var PARAM = 'preview';
  var QV_SELECTOR = 'quick-view[id^="Quickview-"]';
  var closingFromHistory = false;

  function currentHandle() {
    try {
      return new URLSearchParams(window.location.search).get(PARAM);
    } catch (e) {
      return null;
    }
  }

  function handleFromHref(href) {
    if (!href) return null;
    var parts = href.split('/products/');
    if (parts.length < 2) return null;
    return parts[1].split('?')[0].split('#')[0];
  }

  function triggerForHandle(handle) {
    var triggers = document.querySelectorAll('.vzone__mini[aria-controls]');
    for (var i = 0; i < triggers.length; i++) {
      if (handleFromHref(triggers[i].getAttribute('href')) === handle) {
        return triggers[i];
      }
    }
    return null;
  }

  function openPanel() {
    return document.querySelector(QV_SELECTOR + ':not([hidden])');
  }

  /* Opening: record it in history so back can undo it. */
  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest
      ? e.target.closest('.vzone__mini[aria-controls]')
      : null;
    if (!trigger) return;

    var handle = handleFromHref(trigger.getAttribute('href'));
    if (!handle) return;

    var url = new URL(window.location.href);
    url.searchParams.set(PARAM, handle);
    history.pushState({ vzone: handle }, '', url.toString());
  });

  /* Closing by any theme-native path: unwind the entry we pushed. */
  function watch(panel) {
    var observer = new MutationObserver(function () {
      if (!panel.hasAttribute('hidden')) return;
      if (closingFromHistory) return;
      if (!currentHandle()) return;
      history.back();
    });
    observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  }

  var panels = document.querySelectorAll(QV_SELECTOR);
  for (var i = 0; i < panels.length; i++) watch(panels[i]);

  /* Back button: close whatever is open. */
  window.addEventListener('popstate', function () {
    if (currentHandle()) return;
    var panel = openPanel();
    if (!panel) return;

    closingFromHistory = true;
    var close = panel.querySelector('.drawer__close');
    if (close) close.click();
    setTimeout(function () {
      closingFromHistory = false;
    }, 0);
  });

  /* Deep link: open the panel, but leave a clean entry underneath it. */
  window.addEventListener('load', function () {
    var handle = currentHandle();
    if (!handle) return;

    var clean = new URL(window.location.href);
    clean.searchParams.delete(PARAM);
    history.replaceState({}, '', clean.toString());

    var trigger = triggerForHandle(handle);
    if (trigger) trigger.click();
  });
})();
